import React, { useEffect, useRef, useState } from 'react';
import styles from '../../css/style.module.css';
import HOC from '../../components/HOC/HOC';
import { Link } from 'react-router-dom';
import { SuccessfullyModal } from '../../components/Modals/Modals';
import { getApi, postApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

const SendNotifications = () => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [userLoading, setUserLoading] = useState(false);
    const [staffLoading, setStaffLoading] = useState(false);

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [sendTo, setSendTo] = useState('');
    const [userType, setUserType] = useState('');

    // For single selection
    const [singleUserId, setSingleUserId] = useState('');

    // For multiple selection
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState([]);

    const [users, setUsers] = useState([]);
    const [staff, setStaff] = useState([]);

    const handleSend = async () => {
        if (!title || !description || !sendTo || !userType) {
            alert('Please fill all required fields');
            return;
        }

        let payloads = [];

        if (sendTo === 'All') {
            payloads.push({
                title,
                message: description,
                userType: userType === 'All' ? 'BOTH' : userType,
                userId: 'ALL' // Special indicator for all
            });
        } else if (sendTo === 'Single') {
            if (!singleUserId) {
                alert('Please select a user/staff');
                return;
            }
            payloads.push({
                title,
                message: description,
                userType,
                userId: singleUserId
            });
        } else if (sendTo === 'Multiple') {
            const selectedIds = userType === 'USER'
                ? selectedUsers
                : userType === 'STAFF'
                    ? selectedStaff
                    : [...selectedUsers, ...selectedStaff];

            if (selectedIds.length === 0) {
                alert('Please select at least one recipient');
                return;
            }

            payloads.push({
                title,
                message: description,
                userType,
                userId: selectedIds
            });
        }

        try {
            setLoading(true);
            // Send all notifications
            const promises = payloads.map(payload =>
                postApi(endPoints.sendNotification, payload)
            );

            await Promise.all(promises);

            setTitle('');
            setDescription('');
            setSendTo('');
            setUserType('');
            setSingleUserId('');
            setSelectedUsers([]);
            setSelectedStaff([]);
            setShow(true);

            setTimeout(() => {
                setShow(false);
            }, 2000);
        } catch (error) {
            console.error('Error sending notifications:', error);
            alert('Failed to send some notifications');
        } finally {
            setLoading(false);
        }
    };

    const routeMapping = {
        'Send Notification': "/notification/send",
        'All Notifications': "/notification/all",
    };

    const fetchData = async () => {
        await getApi(endPoints.getallstaff, {
            setResponse: setStaff,
            setLoading: setStaffLoading,
            errorMsg: 'Failed to fetch staff!'
        });
    };

    const fetchData1 = async () => {
        await getApi(endPoints.getalluserwithoutpagi, {
            setResponse: setUsers,
            setLoading: setUserLoading,
            errorMsg: 'Failed to fetch user!'
        });
    };

    useEffect(() => {
        fetchData();
        fetchData1();
    }, []);

    const MultiSelectCheckbox = ({
        options,
        selectedValues,
        onSelect,
        onRemove,
        placeholder,
        valueField = '_id',
        labelField = 'name',
        disabled = false
    }) => {
        const [isOpen, setIsOpen] = useState(false);
        const wrapperRef = useRef(null);

        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        useEffect(() => {
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }, []);

        return (
            <div className={styles.multiSelectWrapper} ref={wrapperRef}>
                <div
                    className={`${styles.selectInput} ${disabled ? styles.disabled : ''}`}
                    onClick={() => !disabled && setIsOpen(!isOpen)}
                >
                    {placeholder}
                    {disabled && <span className={styles.disabledText}>(Select user type first)</span>}
                </div>

                {isOpen && (
                    <div className={styles.dropdown}>
                        {options?.length > 0 ? (
                            options.map((option) => (
                                <label
                                    key={option[valueField]}
                                    className={styles.optionItem}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedValues?.includes(option[valueField])}
                                        onChange={(e) =>
                                            e.target.checked
                                                ? onSelect(option[valueField])
                                                : onRemove(option[valueField])
                                        }
                                        disabled={disabled}
                                    />
                                    {option[labelField]}
                                    {labelField === 'firstName' && option.lastName && ` ${option.lastName}`}
                                    {option.Id && ` (ID: ${option.Id})`}
                                </label>
                            ))
                        ) : (
                            <div className={styles.noOptions}>No options available</div>
                        )}
                    </div>
                )}

                <div className={styles.selectedTags}>
                    {selectedValues?.map((value) => {
                        const option = options.find(opt => opt[valueField] === value);
                        return (
                            <div key={value} className={styles.tag}>
                                <span>
                                    {option?.[labelField]}
                                    {labelField === 'firstName' && option?.lastName && ` ${option.lastName}`}
                                </span>
                                <button
                                    type="button"
                                    className={styles.removeBtn}
                                    onClick={() => onRemove(value)}
                                    disabled={disabled}
                                >
                                    ×
                                </button>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    return (
        <>
            <SuccessfullyModal
                show={show}
                handleClose={() => setShow(false)}
                text={"Notifications Sent Successfully"}
            />
            <div className={styles.jobmanagementCotainer}>
                <div className={styles.jobtoppart}>
                    <div className={styles.pagetitle}>
                        <h6>Send Notifications</h6>
                    </div>
                    <div className={styles.rightbuttons}>
                        <div className={styles.rightbuttons2} onClick={handleSend}>
                            <p>{loading ? "Sending..." : "Send"}</p>
                        </div>
                    </div>
                </div>
                <div className={styles.jobselectcontainer}>
                    <div className={styles.jobStatusContainer}>
                        {['Send Notification', 'All Notifications'].map((item, index) => (
                            <Link key={index} to={routeMapping[item]} className={styles.link}>
                                <p
                                    className={
                                        item === 'Send Notification'
                                            ? styles.jobOptionTrueactive
                                            : styles.jobOptionnotactive
                                    }
                                >
                                    {item}
                                </p>
                            </Link>
                        ))}
                    </div>
                </div>
                <div className={styles.jobchildcontainer}>
                    <div className={styles.addcontactdetails}>
                        <div className={styles.addjobinputs}>
                            <label htmlFor="">Send To*</label>
                            <select
                                onChange={(e) => {
                                    setSendTo(e.target.value);
                                    setSingleUserId('');
                                    setSelectedUsers([]);
                                    setSelectedStaff([]);
                                }}
                                value={sendTo}
                            >
                                <option value="">Select</option>
                                <option value="All">All</option>
                                <option value="Single">Single</option>
                                <option value="Multiple">Multiple</option>
                            </select>
                        </div>
                        <div className={styles.addjobinputs}>
                            <label htmlFor="">User Type*</label>
                            <select
                                onChange={(e) => {
                                    setUserType(e.target.value);
                                    setSingleUserId('');
                                    setSelectedUsers([]);
                                    setSelectedStaff([]);
                                }}
                                value={userType}
                                disabled={!sendTo}
                            >
                                <option value="">Select</option>
                                <option value="USER">User</option>
                                <option value="STAFF">Staff</option>
                                {sendTo === "All" && <option value="All">Both</option>}
                            </select>
                        </div>

                        {sendTo === "Single" && (
                            <>
                                {userType === "USER" && (
                                    <div className={styles.addjobinputs}>
                                        <label htmlFor="">Select User*</label>
                                        <select
                                            value={singleUserId}
                                            onChange={(e) => setSingleUserId(e.target.value)}
                                            disabled={userLoading}
                                        >
                                            <option value="">Select User</option>
                                            {userLoading ? (
                                                <option>Loading...</option>
                                            ) : (
                                                users?.data?.map((user) => (
                                                    <option key={user._id} value={user._id}>
                                                        {user.firstName} {user.lastName}
                                                    </option>
                                                ))
                                            )}
                                        </select>
                                    </div>
                                )}
                                {userType === "STAFF" && (
                                    <div className={styles.addjobinputs}>
                                        <label htmlFor="">Select Staff*</label>
                                        <select
                                            value={singleUserId}
                                            onChange={(e) => setSingleUserId(e.target.value)}
                                            disabled={staffLoading}
                                        >
                                            <option value="">Select Staff</option>
                                            {staffLoading ? (
                                                <option>Loading...</option>
                                            ) : (
                                                staff?.data?.map((user) => (
                                                    <option key={user._id} value={user._id}>
                                                        {user.firstName} {user.lastName} (ID: {user.Id})
                                                    </option>
                                                ))
                                            )}
                                        </select>
                                    </div>
                                )}
                            </>
                        )}

                        {sendTo === "Multiple" && (
                            <>
                                {userType === "USER" && (
                                    <div className={styles.addjobinputs}>
                                        <label htmlFor="">Select Users*</label>
                                        <MultiSelectCheckbox
                                            options={users?.data || []}
                                            selectedValues={selectedUsers}
                                            onSelect={(value) => setSelectedUsers(prev => [...prev, value])}
                                            onRemove={(value) => setSelectedUsers(prev => prev.filter(v => v !== value))}
                                            placeholder="Select users..."
                                            valueField="_id"
                                            labelField="firstName"
                                            disabled={!userType}
                                        />
                                    </div>
                                )}
                                {userType === "STAFF" && (
                                    <div className={styles.addjobinputs}>
                                        <label htmlFor="">Select Staff*</label>
                                        <MultiSelectCheckbox
                                            options={staff?.data || []}
                                            selectedValues={selectedStaff}
                                            onSelect={(value) => setSelectedStaff(prev => [...prev, value])}
                                            onRemove={(value) => setSelectedStaff(prev => prev.filter(v => v !== value))}
                                            placeholder="Select staff..."
                                            valueField="_id"
                                            labelField="firstName"
                                            disabled={!userType}
                                        />
                                    </div>
                                )}
                                {userType === "All" && (
                                    <>
                                        <div className={styles.addjobinputs}>
                                            <label htmlFor="">Select Users*</label>
                                            <MultiSelectCheckbox
                                                options={users?.data || []}
                                                selectedValues={selectedUsers}
                                                onSelect={(value) => setSelectedUsers(prev => [...prev, value])}
                                                onRemove={(value) => setSelectedUsers(prev => prev.filter(v => v !== value))}
                                                placeholder="Select users..."
                                                valueField="_id"
                                                labelField="firstName"
                                            />
                                        </div>
                                        <div className={styles.addjobinputs}>
                                            <label htmlFor="">Select Staff*</label>
                                            <MultiSelectCheckbox
                                                options={staff?.data || []}
                                                selectedValues={selectedStaff}
                                                onSelect={(value) => setSelectedStaff(prev => [...prev, value])}
                                                onRemove={(value) => setSelectedStaff(prev => prev.filter(v => v !== value))}
                                                placeholder="Select staff..."
                                                valueField="_id"
                                                labelField="firstName"
                                            />
                                        </div>
                                    </>
                                )}
                            </>
                        )}

                        <div className={styles.addjobinputs}>
                            <label htmlFor="">Title*</label>
                            <input
                                type="text"
                                placeholder='Enter the title'
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className={styles.addjobinputs}>
                        <label htmlFor="">Description*</label>
                        <textarea
                            placeholder='Enter the description'
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default HOC(SendNotifications);